import { useRef, useEffect, useState } from "react";

function AutoScrollPreview({ children }) {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const scrollEl = scrollRef.current;
    if (!scrollEl) return;

    let animationFrame;
    let direction = 1;
    const speed = 0.4;

    const startScrolling = () => {
      // Only start if content is taller than container
      if (scrollEl.scrollHeight <= scrollEl.clientHeight) return;

      // Start from middle
      scrollEl.scrollTop = scrollEl.scrollHeight / 2;

      const scrollStep = () => {
        if (!scrollEl) return;

        if (!isPaused) {
          scrollEl.scrollTop += speed * direction;

          if (scrollEl.scrollTop >= scrollEl.scrollHeight - scrollEl.clientHeight) {
            direction = -1;
          }

          if (scrollEl.scrollTop <= 0) {
            direction = 1;
          }
        }

        animationFrame = requestAnimationFrame(scrollStep);
      };

      animationFrame = requestAnimationFrame(scrollStep);
    };

    // Delay slightly to allow PDF/image rendering (important for mobile)
    const timeout = setTimeout(startScrolling, 500);

    return () => {
      clearTimeout(timeout);
      cancelAnimationFrame(animationFrame);
    };
  }, [children, isPaused]);

  return (
    <div
      ref={scrollRef}
      className="h-40 overflow-y-auto bg-gray-100 p-2 text-sm text-gray-600"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {children}
    </div>
  );
}

export default AutoScrollPreview;